import axios from "axios";
import {
	errorInterceptor,
	requestInterceptor,
	responseInterceptor,
} from "../Utils/apiHelper";

const API = axios.create({ baseURL: process.env.REACT_APP_ENDPOINT });

API.interceptors.request.use((req) => {
	req = requestInterceptor(req);
	return req;
});
API.interceptors.response.use(
	(res) => {
		res = responseInterceptor(res);
		return res;
	},
	async (error) => {
		error = await errorInterceptor(error);
		return Promise.reject(error);
	}
);

export const signOut = (data) => API.post("/api/v1/users/signout", data);
export const signIn = (data) => API.post("/api/v1/users/signin", data);
export const getSignInGoogleLink = () => API.get("/api/v1/users/signin/google");
export const socialSignIn = (data) =>
	API.put("/api/v1/users/signin/social/getdata", data);
export const signUp = (data) => API.post("/api/v1/users/signup", data);
export const accountConfirm = (data) =>
	API.put("/api/v1/users/confirmation", data);
export const getProfile = (data) =>
	API.get("/api/v1/users/get", { params: { username: data } });
export const findUser = (data) =>
	API.get("/api/v1/users/find", { params: { q: data } });

export const addNewPost = (data) => API.post("/api/v1/posts/create", data);
export const getPostProfile = (data) =>
	API.get("/api/v1/posts/get", {
		params: { username: data.username, page: data.page },
	});
export const getPost = (data) =>
	API.get("/api/v1/posts/get", { params: { page: data.page } });
export const getPostQuery = (data) =>
	API.get("/api/v1/posts/get", { params: { page: data.page, q: data.query } });
export const userLiking = (data) => API.put("/api/v1/posts/like", data);
export const deletePost = (data) => API.put("/api/v1/posts/delete", data);

export const addNewNft = (data) =>
	API.post("/api/v1/blockchain/nft/create", data);
export const getAllNft = (data) =>
	API.post("/api/v1/blockchain/nft/get/all", data);

export const getNewAccessToken = (data) => API.post("/api/v1/auth/token", data);

export const userFollowing = (data) => API.put("/api/v1/friendship", data);

export const updateProfile = (data) =>
	API.put("/api/v1/settings/profile/update", data);
export const updateConnectedWallet = (data) =>
	API.put("/api/v1/settings/wallet/set", data);

export const addComment = (data) => API.post("/api/v1/comment/create", data);
export const deleteComment = (data) => API.put("/api/v1/comment/delete", data);
export const getComment = (data) => API.post("/api/v1/comment/get", data);

export const getS3UploadUrl = (data) => API.put("/api/v1/aws/getLink", data);
export const exploreSearch = (data) =>
	API.get("/api/v1/search", { params: { q: data } });
